export const LOCAL_FEATURE_FLAGS = {
	DIGITAL_MENU_CONFIG: true,
	OPERATION_MODE_VITRINE: true,
	OPERATION_MODE_POS_PAGO: false, // backend ainda não suporta cobrança no cardápio
	OPERATION_MODE_PRE_PAGO: false,
} as const;
